import React from "react";
import { Card, CardContent, Box, Chip, Grid, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { formatNumber, formatCurrency } from "../utils/numberFormatter";
import { countConsecutiveNetIncome } from "../utils/classifyNetIncome";

export default function StarsComponent({ ticker, apiData, showStars }) {

  const arrNetIncome = apiData.financial_data.financials?.map (item => item.netIncome);

  // starItems fixos dentro do componente
  const starItems = [
    "+10Y Profit",
    "Debt/EBITDA ≤ 2x",
    "Margin ≥ 5%",
    "Cash ≥ Short Debt",
  ];

  const info = apiData?.info ?? {};

  return (
    <Card
      sx={{
        backgroundColor: "#1e1e1e",
        color: "#fff",
        borderRadius: "16px",
        padding: "16px",
        width: "100%",
        maxWidth: "800px",
        margin: "0 auto",
        boxShadow: "0 4px 12px rgba(0,0,0,0.5)",
      }}
    >
      

      {/* Main Info */}
      <CardContent>
        <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
          {ticker} - {info?.longName ?? "—"}
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Market Cap
            </Typography>
            <Typography variant="body1">
              {formatNumber(info?.marketCap)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Industry Key
            </Typography>
            <Typography variant="body1">
              {info?.industryKey ? `(${info.industryKey})` : "—"}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Last Price
            </Typography>
            <Typography variant="body1">{formatCurrency(apiData?.lastPrice,'','')}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" color="gray">
              Consecutive profitable years
            </Typography>
            <Typography variant="body1">
              {countConsecutiveNetIncome(arrNetIncome)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>

      {/* Top Stars Section */}
      {showStars && 
      
        <Box sx={{ display: "flex", gap: 0.5, marginBottom: 2, flexWrap: "wrap" }}>
        {starItems.map((label, index) => (
          <Chip
            key={`${label}-${index}`}
            icon={
              <StarIcon
                sx={{
                  fontSize: "28px",
                  fill: "url(#goldGradient)", // aplica o gradiente
                }}
              />
            }
            label={label}
            sx={{
              backgroundColor: "#2c2c2c",
              color: "#fff",
              fontWeight: "bold",
              padding: "4px 8px",
            }}
          />
        ))}

        {/* SVG invisível para definir o gradiente */}
        <svg width="0" height="0">
          <defs>
            <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop stopColor="#FFD700" offset="0%" />
              <stop stopColor="#FFC107" offset="100%" />
            </linearGradient>
          </defs>
        </svg>
        </Box>
      }
    </Card>
  );
}
